import { createContext, useContext, useState } from 'react';

const DonationContext = createContext();

export function DonationProvider({ children }) {
    const [donation, setDonation] = useState({
        id: null,
        amount: null,
        frequency: 'one_time',
        personalInfo: {},
        paymentMethod: null,
        isAnonymous: false
    });

    const updateDonation = (data) => {
        setDonation(prev => ({ ...prev, ...data }));
    };

    const resetDonation = () => {
        setDonation({
            id: null,
            amount: null,
            frequency: 'one_time',
            personalInfo: {},
            paymentMethod: null,
            isAnonymous: false
        });
    };

    return (
        <DonationContext.Provider
            value={{
                donation,
                updateDonation,
                resetDonation
            }}
        >
            {children}
        </DonationContext.Provider>
    );
}

export function useDonation() {
    const context = useContext(DonationContext);
    if (!context) {
        throw new Error('useDonation debe usarse dentro de un DonationProvider');
    }
    return context;
}